
import { LineItemMarkupTier } from '@/types/line-item-markup-tiers';

export const hasValidCustomTiers = (tiers: LineItemMarkupTier[]): boolean => {
  if (!tiers || tiers.length === 0) return false;
  
  return tiers.some(tier => 
    tier.min_amount >= 0 && 
    (tier.max_amount === null || tier.max_amount > tier.min_amount)
  );
};

export const findApplicableTier = (tiers: LineItemMarkupTier[], targetAmount: number): LineItemMarkupTier | null => {
  if (!tiers || tiers.length === 0) return null;
  
  return tiers.find(tier => 
    targetAmount >= tier.min_amount && 
    (tier.max_amount === null || targetAmount < tier.max_amount)
  ) || null;
};
